import { useContext } from 'react';
import { InitialDataContext } from '../../providers/InitialDataProvider';

export default function useInitialData() {
  return useContext(InitialDataContext);
}
